<script setup lang="ts">
// ⚠️ Could not locate Tag.vue
import Tag from 'primevue/tag'
import Button from '@/components/Button.vue'

const { $content } = useNuxtApp()

import { KIOE } from '@/utility/utility'

const router = useRouter()

const props = withDefaults(defineProps<{
  item: {
    titles: Record<string, string>,
    description: {
      short: string,
      full: string,
    },
    category: string,
    image: string,
    slug: string,
  }
}>(), {
  item: () => {
    return {
      titles: {
        card: "",
        admin: "",
        short: "",
        long: "",
        page: "",
        introHairline: "",
      },
      description: {
        short: "",
        full: "",
      },
      category: "",
      image: "/images/12.jpg",
      slug: "",
    }
  },
})

const category = computed(() => props.item?.category)
const categoryLabel = computed(() => {
  if (category.value) {
    switch (category.value) {
      case 'ethanol':
        return 'Ethanol Blends'
      case 'essential-chemicals':
        return 'Essential Chemicals'
      case 'manufactured-products':
        return 'Manufactured Products'
      default:
        return category.value
    }
  }
})

const redirect = (slug: string) => {
  router.push(`/product/${slug}`)
}


const productCategoryObj = computed(() => $content?.productCategories.find(pc => pc.slug === props.item.category))


const categoryColor = computed(() => {
  if (KIOE(productCategoryObj.value, 'color')) {
    return productCategoryObj.value?.color || '#000000'
  }
})

</script>

<template>
  <Section class="product-card" w="max-w-92% mx-auto flex flex-col g-0.5">
    <Section class="sec-card-header  relative" w="w-full h-full flex items-center">

      <div v-if="false" class="sec-tags">
        <div class="tags top-left">
          <Tag class="new" severity="info" value="new" />
        </div>
      </div>
      <Section class="sec-image" w="h-full flex justify-center items-center">
        <img :src="`/images/products/${item.slug}/${item.image}`" :alt="item.titles?.short" />
      </Section>

      <div class="sec-category">
        <!-- <div class="span icon">
          <span :style="{ color: categoryColor }">{{ categoryLabel }}</span>
        </div> -->
        <span :style="{ color: categoryColor }">{{ categoryLabel }}</span>
      </div>

      <!-- <div v-if="category" class="sec-item-code" :class="category">
        <span>{{ categoryLabel }}</span>
      </div> -->

      <div v-if="item.origin" class="card-label origin-label" :class="item.origin">
        <span> {{ item.origin }} </span>
      </div>

      <div v-if="item.denaturation" class="card-label denatured-label" :class="item.denaturation">
        <span> {{ item.denaturation }} </span>
      </div>
    </Section>
    <Section class="sec-card-body">
      
      <Wrap class="max-w-85% mx-auto grid g-0.75">
        <div class="sec-title grid g-0.25">
          <div class="title"> {{ item.titles?.card }} </div>
        </div>
        <div class="sec-description">
          {{ item.description.short }}
        </div>
      </Wrap>
      

    </Section>

    <Section class="sec-card-footer" w="max-w-85% mx-auto">

      <div class="sec-actions gpt-0.5 gpb-1">
        <Button btn="blue" class="gpy-0.5 gpx-1.25 fs--1 fw-600 flex items-center g-0.5" @click="redirect(item.slug)">View Product</Button>
      </div>
    </Section>
  </Section>
</template>

<style lang="scss" scoped>
.product-card {

  // This is the background container
  width: 100%;
  // width: 400px;


  display: flex;
  flex-direction: column;

  :deep(>.m-wrap) {
    flex: 1;
    background: white;
    width: 100%;
    height: 100%;
    @apply rounded-xl;
    overflow: hidden;

    @include mq($until: txs) {
      max-width: 380px;
    }


    .sec-card-header {
      
      min-height: 250px;

      .sec-tags {
        position: absolute;
        top: gr(0.5);
        left: gr(0.5);
        // width: 100%;
        // height: 100%;
        z-index: 1;

        .new {
          background: transparent;
          color: white;
          color: var(--base-600);
          font-weight: 400;
          font-size: 11px;
          text-transform: uppercase;
          @apply tracking-wider;
          border: 1px solid var(--base-500);
          border-radius: 30px;
          padding: 0.125rem 0.5rem;
        }
      }

      .sec-image {
        overflow: hidden;
        display: flex;
        justify-content: center;
        align-items: center;
        aspect-ratio: 4 / 2.75; // explicitly define the aspect ratio

        img {
          width: auto;
          height: 100%; // utilize the full height of the container
          object-fit: cover; // maintain aspect ratio and fill the container
          object-position: center; // center the image within the container
          transition: all 0.3s ease-in-out;
        }
      }

      .sec-category {
        background: white;
        position: absolute;
        top: gr(0.5);
        left: gr(0.5);
        transform: 1px;
        padding: gr(0.1125) gr(0.33) gr(0.1125) gr(0.33);
        font-size: 11px;
        text-transform: uppercase;
        @apply tracking-wider;
        font-weight: 500;
        border-radius: 30px;
        border: 1px solid var(--base-500);
      }
      .card-label {
        position: absolute;
        bottom: gr(0.3);
        left: gr(0.75);
        transform: 1px;
        padding: gr(0.075) gr(0.33) gr(0.075) gr(0.33);
        font-size: 11px;
        text-transform: uppercase;
        @apply tracking-wider;
        font-weight: 500;
        border-radius: 30px;
        background: white;
        transition: all 0.2s ease;
        // border: 1px solid var(--base-200);

        &.origin-label {

          &.natural {
            color: var(--green-500);
            border: 1px solid var(--green-300);
            transform: translateX(-5px);
          }

          &.synthetic {
            color: var(--indigo-500);
            // border: 1px solid var(--purple-500);
            border: 1px solid var(--indigo-400);
            transform: translateX(-5px);
          }

        }

        &.denatured-label {
          left: auto;
          right: gr(0.5);

          &.denatured {
            color: var(--pink-400);
            border: 1px solid var(--pink-300);
          }

          &.undenatured {
            color: var(--c-sky-blue);
            border: 1px solid var(--c-sky-blue);
            // border: 1px solid var(--c-blue-500);
          }
        }
      }

      .sec-item-code {
        background: white;
        position: absolute;
        top: 0;
        left: 0;
        transform: translateY(-1px);
        padding: gr(0.225) gr(0.75) gr(0.1125) gr(0.5);
        font-size: 11px;
        text-transform: uppercase;
        @apply tracking-wide;
        font-weight: 500;
        // box-shadow: inset 0 0 0 1px rgba(0, 0, 255, 0.1);


        transition: background-color 0.2s ease, color 0.2s ease, border-color 0.2s ease;
        // box-shadow: inset 0 0 0 1px rgba(0, 0, 255, 0.1);

        span {
          position: relative;
          display:inline-block;
          // transform: translateY(-1px);
        }

        &.ethanol {
          background: var(--sky-50);
          color: var(--sky-600);
        }

        &.manufactured-products {
          background: var(--emerald-50);
          color: var(--emerald-600);
        }

        &.essential-chemicals {
          background: var(--violet-50);
          color: var(--violet-500);
        }

        // border-radius: 0 0.25rem 0 0;
      }
    }

    .sec-card-body {
      flex: 1;

      transition: all 0.2s ease;

      .sec-title {
        .title {
          font-size: fs(1.5);
          font-weight: 400;
          font-size: 22px;
          line-height: gr(1.2);
          color: rgb(4, 61, 117);
        }
      }
      .sec-description {
        color: var(--base-600);
        font-size: fs(-0.5);
      }
    }

    .sec-card-footer {
      flex: 1;
      .p-button {
        &.btn-product {
          padding: gr(0.4) gr(0.8);
          font-size: 13px;
          color:white !important;
          &:hover {
            // background: var(--i-yellow-green);
          }
        }
      }
    }

    .sec-card-footer {
      flex: 1;
    }

    &:hover {
      .sec-card-header {
        .sec-image {
          img {
            transform: scale(1.1);
          }
        }
        .sec-item-code {
          color: var(--c-sky-blue);
          padding-bottom: gr(0.2);
          background: #22beff;
          color: white;
        }

        .card-label {
          position: absolute;
          transform: 1px;
          // padding: gr(0.1125) gr(0.33) gr(0.1125) gr(0.33);
          // font-size: 11.5px;
          text-transform: uppercase;
          @apply tracking-wider;
          font-weight: 500;
          border-radius: 30px;
          // background: white;


          &.origin-label {

            // border: 1px solid var(--orange-500);

            // &.natural {
            //   background: var(--emerald-400);
            //   color:white;
            //   border-color: var(--emerald-400);
            // }

            // &.synthetic {
            //   background: var(--indigo-400);
            //   color:white;
            //   border-color: var(--indigo-400);
            // }

          }

          &.denatured-label {
            // color: white;
            left: auto;
            right: gr(0.5);

            // &.denatured {
            //   background: var(--pink-500);
            //   color: white;
            //   border-color: var(--pink-500);
            // }

            // &.undenatured {
            //   background: var(--c-sky-blue);
            //   color: white;
            //   border-color: var(--c-sky-blue);
            // }
          }
        }
      }

      .sec-card-body {
        transform: translateY(-2px);
        .sec-title {
          .title {
            // color: var(--c-sky-blue);
            color: #0051a8;
          }
        }
      }

      .sec-card-footer {
        display: block;

       
      }
    }
  }



}
</style>